module.exports = __webpack_public_path__ + "static/media/addRegMeetKan.ac279281.jpg";